<template>
    <nav class="ml-5 hidden items-center space-x-7 lg:flex xl:space-x-7">
        <HeaderDropdown
            label="Услуги"
            dropdown-class="container w-full rounded-20 left-0 top-[calc(100%_-_1px)] xl:top-[calc(100%_+_1.5px)] "
            chevron-left
            chevron-right
            :is-open="openMenu === 'service'"
            @close="closeMenu"
            @open="openProductMenuHandler">
            <HeaderProductionsList
                :items="items"
                class="px-10 pb-10"
                @close="closeMenuImmediately" />
        </HeaderDropdown>
        <HeaderNavItem to="/portfolio"> Портфолио</HeaderNavItem>
        <HeaderDropdown
            label="Про Cromi"
            dropdown-class="-left-4 top-[calc(100%_+_2rem)] xl:top-[calc(100%_+_2.3rem)] rounded-20 rounded-tl-none"
            chevron-right
            :is-open="openMenu === 'proCromi'"
            class="relative"
            @close="closeMenu"
            @open="openProCromiMenuHandler">
            <!-- class="absolute -left-4 top-[3.5rem] overflow-hidden rounded-20 rounded-tl-none bg-white opacity-0 transition-all duration-300"> -->

            <HeaderLinkList
                :items="proCromiList"
                @close="closeMenuImmediately" />
        </HeaderDropdown>
        <HeaderNavItem to="/contacts"> Контакты</HeaderNavItem>
    </nav>
</template>
<script lang="ts" setup>
import HeaderDropdown from '~/components/layouts/header/HeaderDropdown.vue'
import HeaderLinkList from '~/components/layouts/header/HeaderLinkList.vue'
import HeaderNavItem from '~/components/layouts/header/HeaderNavItem.vue'
import HeaderProductionsList from '~/components/layouts/header/HeaderProductionsList.vue'
import type {
    IHeaderItems,
    IHeaderLinkItem,
} from '~/components/layouts/header/header.types'
import HeaderAllProductsIcon from '~/components/layouts/header/svg/HeaderAllProductsIcon.vue'
import HeaderAudioguidesIcon from '~/components/layouts/header/svg/HeaderAudioguidesIcon.vue'
import HeaderCabinsIcon from '~/components/layouts/header/svg/HeaderCabinsIcon.vue'
import HeaderConferenceSystemsIcon from '~/components/layouts/header/svg/HeaderConferenceSystemsIcon.vue'
import HeaderRadioguidesIcon from '~/components/layouts/header/svg/HeaderRadioguidesIcon.vue'
import HeaderSoundEquipment from '~/components/layouts/header/svg/HeaderSoundEquipment.vue'
import HeaderVideoConferenceIcon from '~/components/layouts/header/svg/HeaderVideoConferenceIcon.vue'

type Timeout = ReturnType<typeof setTimeout>

const items: IHeaderItems[] = [
    {
        title: 'Оборудование синхронного перевода',
        to: '/arenda-oborudovanie-dlya-sinhronnogo-perevoda',
        icon: HeaderCabinsIcon,
    },
    {
        title: 'Конференц-системы',
        to: '/arenda-konferents-system',
        icon: HeaderConferenceSystemsIcon,
    },
    {
        title: 'Звуковое оборудование',
        to: '/arenda-zvuka',
        icon: HeaderSoundEquipment,
    },
    {
        title: 'Видеоконференции и онлайн мероприятия',
        to: '/arenda-video',
        icon: HeaderVideoConferenceIcon,
    },
    {
        title: 'Радиогиды',
        to: '/arenda-radioguides',
        icon: HeaderRadioguidesIcon,
    },
    {
        title: 'Аудиогиды',
        to: '/arenda-audioguides',
        icon: HeaderAudioguidesIcon,
    },
    {
        title: 'Каталог оборудования',
        to: '/catalog',
        icon: HeaderAllProductsIcon,
    },
]
const proCromiList: IHeaderLinkItem[] = [
    {
        title: 'О компании',
        icon: 'logo',
        link: '/about',
    },
    {
        title: 'Отзывы',
        icon: 'star',
        link: '/reviews',
    },
    {
        title: 'Оплата',
        icon: 'car',
        link: '/pay',
    },
    {
        title: 'Вопрос-ответ',
        icon: 'question',
        link: '/faq',
    },
    {
        title: 'Видео',
        icon: 'video',
        link: '/videos',
    },
    {
        title: 'Блог PRO',
        icon: 'note',
        link: '/pro',
    },
]

const openTimer = ref<null | Timeout>(null)
const closeTimer = ref<null | Timeout>(null)
const OPEN_TIMEOUT = 150
const CLOSE_TIMEOUT = 300
const closeMenuTimeout = ref<null | Timeout>(null)
const openMenu: Ref<null | 'service' | 'proCromi'> = ref(null)

const openProductMenuHandler = () => {
    if (closeTimer.value) clearTimeout(closeTimer.value)

    openTimer.value = setTimeout(() => {
        openMenuHandler('service')
    }, OPEN_TIMEOUT)
}

const openProCromiMenuHandler = () => {
    if (closeTimer.value) clearTimeout(closeTimer.value)

    openTimer.value = setTimeout(() => {
        openMenuHandler('proCromi')
    }, OPEN_TIMEOUT)
}

const closeMenu = () => {
    if (openTimer.value) clearTimeout(openTimer.value)

    closeTimer.value = setTimeout(() => {
        openMenu.value = null
    }, CLOSE_TIMEOUT)
}

function openMenuHandler(menu: 'service' | 'proCromi') {
    if (closeMenuTimeout.value) {
        clearTimeout(closeMenuTimeout.value)
        closeMenuTimeout.value = null
    }

    openMenu.value = menu
}

function closeMenuImmediately(): void {
    queueMicrotask(() => {
        closeMenu()
    })
}

onBeforeUnmount(() => {
    if (openTimer.value) clearTimeout(openTimer.value)
    if (closeTimer.value) clearTimeout(closeTimer.value)
})

// useSchemaOrg([
//     defineItemList({
//         name: 'Основная навигация',
//         itemListElement: proCromiList.map((item) => {
//             return defineListItem({
//                 '@type': 'SiteNavigationElement',
//                 name: item.title,
//                 url: item.link.endsWith('/') ? item.link : item.link + '/',
//             })
//         }),
//     }),
// ])
</script>
